import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { accRechByDay, accRechByDay_currency } from "@/api/dataAll/accRechgeRink";
import { mapState } from 'vuex';
export default {
  name: "accRechRankByDayOneSummary",
  mixins: [tabulation],
  data: function data() {
    var _ref;

    return _ref = {
      more: true,
      tableHead: [],
      value2: [],
      searchData: {
        starttime: "",
        endtime: ""
      },
      tableData: []
    }, _defineProperty(_ref, "more", true), _defineProperty(_ref, "showHeader", []), _defineProperty(_ref, "Header", [{
      label: this.$t('nameLabel'),
      prop: 'role_name'
    }, {
      label: this.$t('serverId'),
      prop: 'server_id'
    }, {
      label: this.$t('currentLevel'),
      prop: 'level'
    }, {
      label: this.$t('fightingPower'),
      prop: 'fighting'
    }, {
      label: this.$t('accountTotalRecharge'),
      prop: 'upMoney'
    }, {
      label: this.$t('roleRechargeAmount'),
      prop: 'upMoneyUser'
    }, {
      label: this.$t('userId'),
      prop: 'user_id'
    }, {
      label: this.$t('roleId'),
      prop: 'role_id'
    }, {
      label: this.$t('vipLevel'),
      prop: 'vip'
    }, {
      label: this.$t('lastLoginTime'),
      prop: 'last_login_time'
    }, {
      label: this.$t('userRegisterTimeLabel'),
      prop: 'register_time'
    }]), _defineProperty(_ref, "HeaderVND", [{
      label: this.$t('nameLabel'),
      prop: 'role_name'
    }, {
      label: this.$t('serverId'),
      prop: 'server_id'
    }, {
      label: this.$t('currentLevel'),
      prop: 'level'
    }, {
      label: this.$t('fightingPower'),
      prop: 'fighting'
    }, {
      label: this.$t('rechargeAmountNew'),
      prop: 'upMoney'
    }, {
      label: this.$t('currencyAmountVnd'),
      prop: 'upMoneyexchange'
    }, {
      label: this.$t('userTotalRechargeAmount'),
      prop: 'upMoneyUser'
    }, {
      label: this.$t('userTotalRechargeAmountVnd'),
      prop: 'upMoneyUserexchange'
    }, {
      label: this.$t('userId'),
      prop: 'user_id'
    }, {
      label: this.$t('roleId'),
      prop: 'role_id'
    }, {
      label: this.$t('vipLevel'),
      prop: 'vip'
    }, {
      label: this.$t('lastLoginTime'),
      prop: 'last_login_time'
    }, {
      label: this.$t('userRegisterTimeLabel'),
      prop: 'register_time'
    }]), _defineProperty(_ref, "HeaderUSD", [{
      label: this.$t('nameLabel'),
      prop: 'role_name'
    }, {
      label: this.$t('serverId'),
      prop: 'server_id'
    }, {
      label: this.$t('currentLevel'),
      prop: 'level'
    }, {
      label: this.$t('fightingPower'),
      prop: 'fighting'
    }, {
      label: this.$t('rechargeAmountNew'),
      prop: 'upMoney'
    }, {
      label: this.$t('currencyAmountUsd'),
      prop: 'upMoneyexchange'
    }, {
      label: this.$t('userTotalRechargeAmount'),
      prop: 'upMoneyUser'
    }, {
      label: this.$t('userTotalRechargeAmountUsd'),
      prop: 'upMoneyUserexchange'
    }, {
      label: this.$t('userId'),
      prop: 'user_id'
    }, {
      label: this.$t('roleId'),
      prop: 'role_id'
    }, {
      label: this.$t('vipLevel'),
      prop: 'vip'
    }, {
      label: this.$t('lastLoginTime'),
      prop: 'last_login_time'
    }, {
      label: this.$t('userRegisterTimeLabel'),
      prop: 'register_time'
    }]), _ref;
  },
  created: function created() {},
  activated: function activated() {// if (this.searchData.game.indexOf(this.royalpirates) > -1) {
    //   this.Header = [
    //     {
    //       label: '名称',
    //       prop: 'role_name'
    //     }, {
    //       label: '服务器ID',
    //       prop: 'server_id'
    //     }, {
    //       label: '当前等级',
    //       prop: 'level'
    //     }, {
    //       label: '战斗力',
    //       prop: 'fighting'
    //     }, {
    //       label: '充值金额',
    //       prop: 'upMoney'
    //     }, {
    //       label: '用户ID',
    //       prop: 'user_id'
    //     }, {
    //       label: '角色ID',
    //       prop: 'role_id'
    //     }, {
    //       label: 'VIP等级',
    //       prop: 'vip'
    //     }, {
    //       label: '最后登录时间',
    //       prop: 'last_login_time'
    //     }
    //   ]
    // } else {
    //   this.Header = [
    //     {
    //       label: '用户ID',
    //       prop: 'user_id'
    //     }, {
    //       label: '充值金额',
    //       prop: 'upMoney'
    //     }
    //   ]
    // }
  },
  computed: _objectSpread({}, mapState('d2admin/serchSelect', ['royalpirates'])),
  methods: {
    rowClick: function rowClick(row, item, prop) {
      if (prop.indexOf('user_id') > -1 && row[prop]) {
        this.$router.replace({
          name: 'orderDisplay',
          params: {
            user_id: row[prop],
            date: item.label,
            type: 'D'
          }
        });
      }
    },
    searchClick: function searchClick(nums) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var reqFn;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // if(this.currencyClose && !this.searchData.currency_info){
                //   this.$message.error('请选择货币类型')
                //   return
                // }
                _this.searchData.starttime = _this.value2[0] || '';
                _this.searchData.endtime = _this.value2[1] || '';
                _this.reqLoading = true;
                _context.next = 5;
                return _this.getexchangeRate();

              case 5:
                if (_this.queryCurrency == 'VND') {
                  _this.showHeader = _this.HeaderUSD;
                } else if (_this.queryCurrency == 'USD') {
                  _this.showHeader = _this.Header;
                } else {
                  _this.showHeader = _this.Header;
                }

                reqFn = _this.currencyClose ? accRechByDay_currency : accRechByDay;
                reqFn(_objectSpread(_objectSpread({}, _this.searchData), _this.defaultData())).then(function (res) {
                  if (res.status == 200) {
                    (function () {
                      _this.resData = res.data.summary ? JSON.parse(res.data.summary) : []; //  = Object.keys(getData).reverse();

                      console.log(" this.resData", _this.resData);
                      _this.tableHead = [];
                      var data = [];

                      var _loop = function _loop(k) {
                        var list = [];
                        var userIds = [];

                        _this.resData[k].forEach(function (j, ji) {
                          if (j.role_id instanceof Array) {
                            userIds.push(j.user_id);
                            j.role_id.forEach(function (l, li) {
                              list.push({
                                user_id: j.user_id,
                                channel: j.channel,
                                role_id: j.role_id[li],
                                server_id: j.server_id[li],
                                fighting: j.fighting[li],
                                last_login_time: j.last_login_time[li],
                                real_time_amount: j.real_time_amount[li],
                                level: j.level[li],
                                recharge_amount: j.recharge_amount[li],
                                role_name: j.role_name[li],
                                vip: j.vip[li]
                              });
                            });
                          }
                        });

                        _this.resData[k] = _this.resData[k].filter(function (obj) {
                          return !userIds.includes(obj.user_id);
                        });
                        _this.resData[k] = [].concat(_toConsumableArray(_this.resData[k]), list);
                      };

                      for (var k in _this.resData) {
                        _loop(k);
                      }

                      var IN = -1;
                      _this.tableHead = _this.showHeader;

                      var _loop2 = function _loop2(i) {
                        _this.resData[i].forEach(function (k, ki) {
                          IN += 1;
                          var taskData = {};

                          _this.showHeader.forEach(function (j, ji) {
                            var Money = Number(i);
                            var ks = k[j.prop];

                            if (j.prop == 'upMoney') {
                              taskData[j.prop] = _this.isyjfmvnd() ? Number(Money).toFixed(3) : _this.$utils.conversion(Money);
                            } else if (j.prop == 'upMoneyexchange') {
                              taskData[j.prop] = _this.isyjfmvnd() ? (Money * _this.exchangeRate).toFixed(3) : _this.$utils.conversion(Money * _this.exchangeRate).toFixed(2);
                            } else if (j.prop == 'upMoneyUser') {
                              taskData[j.prop] = _this.isyjfmvnd() ? k.real_time_amount : _this.$utils.conversion(k.real_time_amount);
                            } else if (j.prop == 'upMoneyUserexchange') {
                              taskData[j.prop] = _this.isyjfmvnd() ? Number(k.real_time_amount * _this.exchangeRate).toFixed(2) : _this.$utils.conversion(k.real_time_amount * _this.exchangeRate).toFixed(2);
                            } else {
                              taskData[j.prop] = ks instanceof Array ? ks.toString() : ks;
                            }

                            if (k.recharge_amount && k.recharge_amount instanceof Array) {
                              if (j.prop.indexOf('upMoney') > -1) {
                                var list = [];
                                var listexchange = [];
                                k.recharge_amount.map(function (s) {
                                  list.push(_this.isyjfmvnd() ? Number(s).toFixed(3) : _this.$utils.conversion(s));
                                  listexchange.push(_this.isyjfmvnd() ? (Number(s) * _this.exchangeRate).toFixed(2) : _this.$utils.conversion(Number(s) * _this.exchangeRate).toFixed(2));
                                });
                                taskData[j.prop] = list.toString();
                                taskData['upMoneyexchange'] = listexchange.toString();
                              }
                            }

                            if (k.real_time_amount && k.real_time_amount instanceof Array) {
                              if (j.prop.indexOf('upMoneyUser') > -1) {
                                var _list = [];
                                var _listexchange = [];
                                k.real_time_amount.map(function (s) {
                                  _list.push(_this.isyjfmvnd() ? Number(s).toFixed(3) : _this.$utils.conversion(s));

                                  _listexchange.push(_this.isyjfmvnd() ? (Number(s) * _this.exchangeRate).toFixed(2) : _this.$utils.conversion(Number(s) * _this.exchangeRate).toFixed(2));
                                });
                                taskData[j.prop] = _list.toString();
                                taskData['upMoneyUserexchange'] = _listexchange.toString();
                              }
                            }
                          });

                          data[IN] = _objectSpread({}, taskData);
                        });
                      };

                      for (var i in _this.resData) {
                        _loop2(i);
                      }

                      _this.tableData = data.reverse();

                      _this.$nextTick(function () {
                        _this.getTableRight();
                      });
                    })();
                  }
                }).finally(function () {
                  _this.reqLoading = false;
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    exportdata: function exportdata() {
      var columns = [];
      columns.push.apply(columns, _toConsumableArray(this.showHeader.map(function (i, ins) {
        return {
          label: i.label,
          prop: i.prop
        };
      })));
      var data = this.tableData;
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};